import {
  Box,
  Container,
  MenuItem,
  Select,
  Card,
  Button,
  Typography,
  Divider,
  Paper,
  Stack,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/styles";
import TngTransactionReportTable from "../../components/table/tngTransactionReportTable";

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    display: "grid",
    gridTemplateColumns: "9fr 1fr",
    columnGap: theme.spacing(2),
  },
}));

export default function TransactionReportsPage({
  handleProviderChange,
  onConfigureNotificationButtonClick,
  provider,
  providers,
  reportFilterButtons,
  activeReportFilterButton,
  onReportFilterButtonClick,
}) {
  const classes = useStyles();

  return (
    <Container maxWidth={false} sx={{ mt: 4 }}>
      {/* <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          pt: 2,
          px: 2,
        }}
      >
        <Card>
          <Box p={1} display="flex" justifyContent="space-between">
            <Select
              value={provider}
              label="Provider"
              onChange={handleProviderChange}
              sx={{
                color: "black",
              }}
            >
              {providers.map((item) => (
                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
              ))}
            </Select>
            <Button variant="contained" color="primary" onClick={onConfigureNotificationButtonClick}>
              Configure Notification
            </Button>
          </Box>
        </Card>
      </Box> */}
      <Box sx={{ display: "flex", gap: 4 }}>
        <Paper elevation={3} sx={{ p: 2, minWidth: 200 }}>
          <Stack spacing={1}>
            {reportFilterButtons.map(({ label, key }) => (
              <Button
                key={key}
                variant={
                  activeReportFilterButton === key ? "contained" : "outlined"
                }
                fullWidth
                onClick={() => onReportFilterButtonClick(key)}
                sx={{ justifyContent: "flex-start" }}
              >
                {label}
              </Button>
            ))}
          </Stack>
        </Paper>
        <Box sx={{ flexGrow: 1 }}>
          {provider === "tng" &&
            activeReportFilterButton === "dailySummary" && (
              <TngTransactionReportTable />
            )}
        </Box>
      </Box>
    </Container>
  );
}
